import clsx from 'clsx';
import styles from '@danske/sapphire-css/components/modalLayout/modalLayout.module.css';
import {
  SapphireStyleProps,
  useSapphireStyleProps,
  useThemeCheck,
} from '../../utils';

import React, { ForwardedRef } from 'react';
import { DOMProps } from '@react-types/shared';
import { Typography } from '../../Typography';
import { GlobalDomAttributes } from '../../utils/types';

export interface ModalLayoutSectionProps
  extends DOMProps,
    GlobalDomAttributes,
    Pick<SapphireStyleProps, 'UNSAFE_style' | 'UNSAFE_className'> {
  title: React.ReactNode;
  children: React.ReactNode;
  isFormSection?: boolean;
}

/**
 * Used inside {@link ModalLayoutBody}.
 *
 */

export const ModalLayoutSection = React.forwardRef(function ModalLayoutSection(
  { title, children, isFormSection, ...otherProps }: ModalLayoutSectionProps,
  forwardedRef: ForwardedRef<HTMLFieldSetElement>
): JSX.Element {
  useThemeCheck();
  const { styleProps, filteredProps } = useSapphireStyleProps(otherProps);

  const SectionElem = isFormSection ? 'fieldset' : 'section';
  const TitleElem = isFormSection ? 'legend' : 'header';

  return (
    <SectionElem
      className={clsx(
        styles['sapphire-modal-layout__section'],
        styleProps.className
      )}
      style={styleProps.style}
      {...filteredProps}
      ref={forwardedRef}
    >
      <TitleElem className={styles['sapphire-modal-layout__section-title']}>
        <Typography.Body size="sm" isSemibold elementType="h5">
          {title}
        </Typography.Body>
      </TitleElem>
      {children}
    </SectionElem>
  );
});
